var exports = {
  "iE": "xaf9ae18d--9f2da2--wrapper",
  "dg": "xaf9ae18d--9f2da2--wrapper--redesign",
  "ag": "xaf9ae18d--9f2da2--balloon",
  "U9": "xaf9ae18d--9f2da2--count",
  "vu": "xaf9ae18d--9f2da2--active",
  "HP": "xaf9ae18d--9f2da2--balloon--hovered",
  "nZ": "xaf9ae18d--9f2da2--balloon--redesign",
  "q9": "xaf9ae18d--9f2da2--price",
  "Kk": "xaf9ae18d--9f2da2--icon",
  "W0": "xaf9ae18d--9f2da2--balloon--redesign-v2",
  "zx": "xaf9ae18d--9f2da2--point",
  "M9": "xaf9ae18d--9f2da2--point--redesign",
  "S7": "xaf9ae18d--9f2da2--point--hovered",
  "bT": "xaf9ae18d--9f2da2--point--active",
  "p5": "xaf9ae18d--9f2da2--point--redesign-v2",
};

module.exports = exports;
